import React from 'react'
import Layout from '../../Layout'
import Category from './Components/Category';
import Header from '../../Components/Header';
import Tab from '../../Components/Tab';
import { useHome } from '../../Hook/App';
function Index() {
  const { scrolled, loadItems, loadCategory, items, categoreis } = useHome();
  
  return (
    <Layout>
      <Header />
      <Category load={loadCategory} scrolled={scrolled} categoreis={categoreis || []} />
      <div className="main" style={!loadCategory ? { paddingBottom: '4rem', paddingTop: scrolled ? '13rem' : '16rem' } : { paddingTop: '12rem' }}>
        <Tab load={loadItems} items={items && items.data || []} keyList="items" />
      </div>
    </Layout>
  )
}



export default Index